import api from "../../config/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ROUTES } from "../../config/apiRoutes";

export const getOrgFormsThunk = createAsyncThunk(
    "organizatiomForm/getOrgFormsThunk",
    async (payload = {}, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        // 👈 Skip API if data already in state
        if (payload.type !== "getForms") {
            if (state.organizatiomForm?.organizatiomForms?.length > 0) {
                return state.organizatiomForm.organizatiomForms;
            }
        }

        try {
            const response = await api.post(API_ROUTES.ORG_FORMS, {
                employee_id: user?.user_id,
            });

            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch Forms");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);

export const getOrgFormFieldsThunk = createAsyncThunk(
    "organizatiomForm/getOrgFormFieldsThunk",
    async (_, { rejectWithValue, getState }) => {
        const state = getState();

        // 👈 Skip API if data already in state
        if (state.organizatiomForm?.formFieldTypes?.length > 0) {
            return state.organizatiomForm.formFieldTypes;
        }

        try {
            const response = await api.post(API_ROUTES.ORG_FORM_FIELDS_TYPES);

            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch Categories");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);

export const createFormThunk = createAsyncThunk(
    "organizatiomForm/createFormThunk",
    async ({ credentials }, { rejectWithValue, getState, dispatch }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            employee_id: user?.user_id,
        };

        try {
            const response = await api.post(API_ROUTES.CREATE_ORG_FORM, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 201) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "Login failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Login failed"
            );
        }
    }
);






export const addFormResponseThunk = createAsyncThunk(
    "organizatiomForm/addFormResponseThunk",
    async ({ credentials }, { rejectWithValue, getState, dispatch }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            employee_id: user?.user_id,
        };

        try {
            const response = await api.post(API_ROUTES.ADD_FORM_RESPONSE, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 201) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "Login failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Login failed"
            );
        }
    }
);